export function getInitials(name: string, maxInitials = Infinity): string {
  return name
    .split(" ")
    .map((word) => word[0])
    .slice(0, maxInitials)
    .join("")
    .toUpperCase();
}

export function getFirstName(name: string): string {
  return name.split(" ")[0];
}
